import { useEffect, useMemo, useState } from 'react';

import { useParams } from 'react-router-dom';

import { useCurrencies } from 'api/useCurrencies';
import useOrders from 'api/useOrders';
import { getQueryParams } from 'utils/queryParamsUtil';

import { Discount } from './Components/Discount';
import { DisputeEvidence } from './Components/DisputeEvidence/DisputeEvidence';
import { History } from './Components/History';
import { OrderDetails } from './Components/OrderDetails';
import { OrderHeader } from './Components/OrderHeader';
import { PaymentDetails } from './Components/PaymentDetails';
import { Products } from './Components/Products';
import { Order as OrderType } from './types';
import { calculateDisplayPrices } from './utils';

export const Order = () => {
  const { orderId } = useParams();
  const publisherId = getQueryParams('publisherId') ?? '';
  const [order, setOrder] = useState<OrderType | undefined>(undefined);
  const { currencyCodeToCurrencyMap } = useCurrencies();
  const { getOrderDetails } = useOrders(orderId, undefined, undefined, {
    selectedProjects: publisherId
  });

  useEffect(() => {
    if (getOrderDetails.isSuccess) {
      setOrder(getOrderDetails.data as unknown as OrderType);
    }
  }, [getOrderDetails.data, getOrderDetails.isSuccess]);

  // Calculate display prices using currency multiplier
  const displayPrices = useMemo(() => {
    if (!order) return null;
    return calculateDisplayPrices(order, currencyCodeToCurrencyMap);
  }, [order, currencyCodeToCurrencyMap]);

  return (
    <div className="p-6 h-[calc(100vh-100px)]">
      <div className="w-full flex flex-col gap-6 font-sans pb-[91px]">
        <OrderHeader
          order={order}
          orderId={orderId ?? ''}
          displayPrices={displayPrices}
        />
        <OrderDetails
          order={order}
          publisherId={publisherId}
          displayPrices={displayPrices}
        />
        <PaymentDetails order={order} displayPrices={displayPrices} />
        <Discount order={order} displayPrices={displayPrices} />
        <Products order={order} />
        <History order={order} />
        <DisputeEvidence
          order={order}
          publisherId={publisherId ?? ''}
          orderId={orderId ?? ''}
        />
      </div>
    </div>
  );
};
